import { createFeatureSelector } from '@ngrx/store';
import { AppUserState } from '../states/app.state';


export const selectCurrentUser = createFeatureSelector<AppUserState>('currentUser');
